module.exports = __webpack_public_path__ + "media/images/lb/319-a04b3ace3c3868f8c4da3656000c0927.svg";